import { Restaurant } from '../types';
import { StarIcon } from './icons';

interface RestaurantCardProps {
    restaurant: Restaurant;
    onClick: () => void;
}

const RestaurantCard: React.FC<RestaurantCardProps> = ({ restaurant, onClick }) => {
    return (
        <div
            className={`group relative w-full h-[280px] rounded-[2rem] overflow-hidden shadow-xl cursor-pointer active:scale-95 transition-all duration-300 bg-gray-100 isolation-isolate z-0 ${!restaurant.isOnline ? 'grayscale brightness-[0.7] opacity-90' : ''}`}
            onClick={onClick}
        >
            {/* Background Image with Hover Effect */}
            <img
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                style={{ transform: 'translateZ(0)' }}
                src={restaurant.image}
                alt={restaurant.name}
            />

            {/* [NEW] "Fermé" Badge Overlay */}
            {!restaurant.isOnline && (
                <div className="absolute inset-0 z-30 flex items-center justify-center pointer-events-none">
                    <div className="bg-black/80 backdrop-blur-md px-6 py-2.5 rounded-2xl border border-white/20 shadow-2xl transform -rotate-3 scale-110">
                        <span className="text-white text-sm font-black uppercase tracking-[0.2em] italic">Fermé</span>
                    </div>
                </div>
            )}

            {/* Gradient Overlay for Text Legibility (Adjusted height) */}
            <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/80 via-black/20 to-transparent pointer-events-none" />

            {/* Badges Container */}
            <div className="absolute top-4 left-4 right-4 flex justify-between items-start z-20">
                {/* Discount Badge */}
                {(restaurant.globalDiscount || 0) > 0 ? (
                    <div className="bg-[#E31E24] text-white text-[10px] font-black px-2.5 py-1 rounded-xl shadow-xl border-b-2 border-black/10">
                        - {restaurant.globalDiscount}%
                    </div>
                ) : <div />}

                {/* Delivery Status Badge */}
                {restaurant.deliveryEnabled === false && (
                    <div className="bg-red-600 text-white text-[9px] font-black px-3 py-1.5 rounded-xl shadow-xl border-b-2 border-black/10 uppercase tracking-widest italic transition-transform hover:scale-105">
                        À Emporter
                    </div>
                )}
            </div>

            {/* Content Overlay (Bottom) */}
            <div className="absolute bottom-0 left-0 right-0 p-5 pt-10">
                <h4 className="text-white text-lg font-black uppercase italic tracking-tighter leading-tight drop-shadow-lg line-clamp-2 mb-2">
                    {restaurant.name}
                </h4>

                <div className="flex items-center gap-2">
                    {/* Rating Pill */}
                    <div className="flex items-center bg-[#FFC107] px-2 py-0.5 rounded-lg shadow-lg border border-white/20">
                        <StarIcon className="w-3 h-3 text-black fill-current mr-1" />
                        <span className="text-xs font-black text-black">{restaurant.rating}</span>
                    </div>
                    {/* Review Count (Subtle) */}
                    <span className="text-[10px] font-bold text-white/40 uppercase tracking-widest">
                        {restaurant.ratingCount || 0} avis
                    </span>
                </div>
            </div>
        </div>
    );
};

export default RestaurantCard;